import React, { lazy } from 'react';
import { Route} from 'react-router-dom';

import { IonTabs, IonRouterOutlet, IonTabBar, IonTabButton, IonIcon, IonLabel } from '@ionic/react';
import { chatbubblesOutline, discOutline, gameControllerOutline, peopleOutline, walletOutline } from 'ionicons/icons';

const Play     = lazy(() => import('./pages/play/play'));
const Friends  = lazy(() => import('./pages/friends/friends'));
const Chat     = lazy(() => import('./pages/chat/chat'));
const Missions = lazy(() => import('./pages/missions/missions'));
const Wallet   = lazy(() => import('./pages/wallet/wallet'));
const GameIntegrationInfo = lazy(() => import('./pages/play/game-integration/game-integration'));

const Profile  = lazy(() => import('./pages/profile/profile'));


const GameSelection = lazy(() => import('./pages/play/game-selection/game-selection'));
const SkillChallenge = lazy(() => import('./pages/play/skill-challenge/skill-challenge'));

const AuthenticatedTabs: React.FC = () => {
  return (
    <IonTabs>
      <IonRouterOutlet>
        <Route exact path='/'><GameSelection /></Route>
        <Route exact path='/friends'><Friends /></Route>
        <Route exact path='/friends/profiles/:id' component={ Profile }></Route>
        <Route exact path='/chat'><Chat /></Route>
        <Route exact path='/play'><GameSelection /></Route>
        <Route path="/play/game-selection" component={GameSelection} exact />
        <Route path="/play/:id/skill-challenge" component={SkillChallenge} exact />
        <Route path="/play/:id/integration-info" component={GameIntegrationInfo} exact />

        <Route exact path='/missions'><Missions /></Route>
        <Route exact path='/wallet'><Wallet /></Route>
      </IonRouterOutlet>

      <IonTabBar slot='bottom'>
        <IonTabButton tab='friends' href='/friends'>
          <IonIcon icon={ peopleOutline } />
          <IonLabel>Friends</IonLabel>
        </IonTabButton>

        {/* <IonTabButton tab='chat' href='/chat'>
          <IonIcon icon={ chatbubblesOutline } />
          <IonLabel>Chat</IonLabel>
        </IonTabButton> */}

        <IonTabButton tab='play' href='/play/game-selection'>
          <IonIcon icon={ gameControllerOutline } />
          <IonLabel>Play</IonLabel>
        </IonTabButton>

        {/* <IonTabButton tab='missions' href='/missions'>
          <IonIcon icon={ discOutline } />
          <IonLabel>Missions</IonLabel>
        </IonTabButton> */}

        <IonTabButton tab='wallet' href='/wallet'>
          <IonIcon icon={ walletOutline } />
          <IonLabel>Wallet</IonLabel>
        </IonTabButton>
      </IonTabBar>
    </IonTabs>
  );
}

export default AuthenticatedTabs;